import { useContext, useEffect, useRef } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

import useLatest from 'utils/hooks/useLatest';
import useUnmount from 'utils/hooks/useUnmount';

const useNavigationBlocker = (onBlocked, isEnabled = true) => {
  const { navigator } = useContext(NavigationContext);

  const unblockRef = useRef(null);
  const onBlockedRef = useLatest(onBlocked);

  const clearBlocker = () => {
    unblockRef.current?.();
    unblockRef.current = null;
  };

  useEffect(() => {
    if (!isEnabled) {
      clearBlocker();
      return;
    }

    if (!unblockRef.current) {
      unblockRef.current = navigator.block((transition) =>
        onBlockedRef.current({
          ...transition,
          retry() {
            unblockRef.current?.();
            unblockRef.current = null;
            transition.retry();
          }
        })
      );
    }
  }, [navigator, isEnabled]);

  useUnmount(clearBlocker);
};

export default useNavigationBlocker;
